import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const WellStageScheduleValidator = t.intersection([
  t.type({
    id: t.string,
    siteId: t.string,
    wellId: t.string,
    regionId: t.string,
    wellStageId: t.string,
    startDttm: t.number,
  }),
  t.partial({
    endDttm: t.number,
    lastReportedDttm: t.number,
    afe: t.string,
    afePrefix: t.string,
    afeSuffix: t.string,
    createdById: t.string,
    lastModifiedById: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const WellStageScheduleArrayValidator = t.array(
  WellStageScheduleValidator
);

export type WellStageSchedule = t.TypeOf<typeof WellStageScheduleValidator>;
export type WellStageScheduleArray = t.TypeOf<
  typeof WellStageScheduleArrayValidator
>;

@Exclude()
export class WellStageScheduleEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  siteId!: string;

  @Expose()
  wellId!: string;

  @Expose()
  regionId!: string;

  @Expose()
  wellStageId!: string;

  @Expose()
  afe?: string

  @Expose()
  afePrefix?: string

  @Expose()
  afeSuffix?: string

  @Expose()
  startDttm!: number;

  @Expose()
  endDttm?: number;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'WELLSTAGES';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for WellStageScheduleEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: WellStageSchedule): WellStageScheduleEntity {
    return plainToInstance(WellStageScheduleEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<WellStageSchedule> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(WellStageScheduleValidator, object);
  }

  asTypeValue(): WellStageSchedule {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(WellStageScheduleValidator, object);
  }
}
